
import {APP_URL, fetchWithToken} from "../../api/apiBase";
import {CopyButton2, CopyText} from "@/src/components/exportData/CopyButton";
import React, {useState} from "react";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";
import {Button} from "../ui/button";
import {Copy} from "lucide-react";
import {useParams} from "react-router-dom";
import {useAuthInfo} from "@propelauth/react";
import {QLinkData} from "../qlink/qlink_model";
import {useToast} from "../ui/use-toast";


type ButtonProps = {
    link_id: string
}


function make_link_url(link_id:string) {
    return `${APP_URL}/qlink/${link_id}`
}

export function CopyQlinkButton({link_id}:ButtonProps){
    const {accessToken} = useAuthInfo();
    const {project_id} = useParams();
        const {toast} = useToast();
    const [linkData, setLinkData] = useState<QLinkData | null>(null);

    const copyLink = (cl: string) => {
        const lid = cl? cl : (linkData? linkData.uuid : null)
        if(lid) {
            const link_url = make_link_url(lid);
            navigator.clipboard.writeText(link_url).then(() => {
                console.log('Data copied to clipboard successfully!');
                toast({
                    title: 'Link copied to Clipboard',
                    description: `${link_url}`,
                    variant: 'default',
                });
            }).catch((err) => {
                // console.error('Failed to copy data:', err);
                toast({
                    title: 'Error',
                    description: 'Failed to copy data!',
                    variant: 'destructive',
                })
            });
        } else {
            toast({
                title: 'Error',
                description: 'Failed to resolve link.',
                variant: 'destructive',
            })
        }
    }

    const handleCopy = () => {
        fetchWithToken(`/qlink/${project_id}/link/${link_id}`, accessToken as string)
            .then((x) => {
                console.log(x)
                setLinkData(x);
                copyLink(x.uuid);
            }).catch(() =>
                toast({
                    title: 'Error',
                    description: 'Failed to retrieve link.',
                    variant: 'destructive',
                })
        )
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                        <Button
                            onClick={handleCopy}
                            type='button'
                            variant="ghost"
                            size="icon"
                            className="h-6 w-6">
                            <Copy className="h-3 w-3" /></Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{"Copy Link"}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>) ;
};
